export const universityConstants = {
  getUniversitiesErrorMessage: 'There was an error fetching universities!',
};
